import FilterDetails from './FilterDetails';

export default FilterDetails;
